export * from './training.component';
export * from './detail/detail/training-detail-detail.component';
export * from './training.state';
export * from './detail/detail.component';
export * from './detail/detail.state';
export * from './detail/description/description.component';
export * from './detail/planning/planning.component';
export * from './detail/planning/detail/detail.component';
export * from './detail/planning/detail/detail.state';
export * from './detail/evaluation/evaluation.component';

export * from './create/create.state';
export * from './create/create.component';



// WEBPACK FOOTER //
// ./src/app/_screens/training/index.ts